import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import Seo from "@/components/Seo";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate(user.is_admin ? "/admin" : "/", { replace: true });
  }, [user, loading, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main data-testid="login-page" className="max-w-2xl mx-auto px-6 py-32 text-center">
      <Seo title="Sign in" path="/login" noindex />
      <div className="text-xs uppercase tracking-[0.25em] text-foreground/60 mb-4">
        Restricted area
      </div>
      <h1 className="font-serif text-5xl md:text-6xl font-light tracking-tighter">
        Sign in with Google
      </h1>
      <p className="mt-6 max-w-lg mx-auto text-foreground/70 leading-relaxed">
        This is the private door for the site owner to manage the journal and,
        eventually, the tools. Everything you read on the public site stays free
        and open.
      </p>
      <button
        onClick={handleLogin}
        data-testid="login-google-btn"
        className="mt-12 inline-flex items-center gap-3 rounded-full bg-primary text-primary-foreground px-8 py-4 text-sm uppercase tracking-widest hover:bg-primary/90 transition-colors"
      >
        Continue with Google
      </button>
      <p className="mt-6 text-xs text-foreground/50">
        The first account to sign in becomes the site owner.
      </p>
    </main>
  );
}
